import React from "react"
import _ from "lodash"
import Alert from "@material-ui/lab/Alert"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  alertBox: {
    margin: theme.spacing(1.5)
  }
}))

/**
 * An alert component that handles several message group by level properly.
 *
 * Messages accept an array of items like:
 * <pre>
 *   const errorMsg = { error: "Here a message error" }
 *   const infoMsg = { info: "Here a message error" }
 *   const messages = [errorMsg, infoMsg]
 * </pre>
 *
 * Example for props:
 * <pre>
 * [
 *    { success: "Success message" },
 *    { info: "Info message" },
 *    { warning: "Warning message" },
 *    { error: "Error Message" }
 * ]
 * </pre>
 *
 *
 * @param props
 * @returns {[]}
 * @constructor
 */
export default function AlertByLevel(props) {
  const classes = useStyles()
  const { message, handleClose } = props
  const messageByLevel = _.groupBy(message, (it) => _.keys(it)[0])
  const alerts = []
  _.forIn(messageByLevel, (messages, level) => {
    const mergeMessage = _(messages)
      .map((it) => it[level])
      .join(". ")

    const closeHandler = handleClose
      ? { onClose: (event) => handleClose(event, level) }
      : {}
    const childProps = {
      ...closeHandler,
      className: classes.alertBox,
      key: `alert-${level}`,
      severity: level
    }
    alerts.push(<Alert {...childProps}>{mergeMessage}</Alert>)
  })
  return alerts
}
